import { defineModule } from '@/app/router/defineModule.ts';
import shouldBeAuthenticated from '@/app/router/middleware/shouldBeAuthenticated.js';

export default defineModule({
    name: 'account',
    routes: [
        {
            path: '/settings',
            name: 'settings',
            component: () => import('#modules/account/pages/index.vue'),
            meta: {
                layout: 'app',
                middleware: [shouldBeAuthenticated],
            },
        },
    ],
});
